import { Modal } from 'antd';
import React, { useState } from 'react';
import { EscalarSla } from '@app/api/sla';
import { Button, Widget, MasterDetailForm } from '@digital/ui';
import { Tooltip } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalEscalarSla {
  id?: string;
  onUpdatePage: () => any;
}

const ModalEscalarSla = (props: PropsModalEscalarSla) => {
  const { id, onUpdatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    EscalarSla({ id, justificativa }).then(data => {
      if (data) {
        if (data.valid) {
          handleCancel();
          onUpdatePage();
        }
      }
    });
  };

  return (
    <>
      <Tooltip title="Submete a análise de SLA ao Gestor MRN">
        <Button
          type="link"
          onClick={() => {
            showModal();
          }}>
          Escalar
        </Button>
      </Tooltip>

      <Modal
        title="ESCALAR SLA"
        width="800px"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={e => Salvar(e)}>
            Escalar Sla
          </Button>,
          <Button key="cancel" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <MasterDetailForm>
          <Widget>
            <TextArea
              name="justificativa"
              id="justificativa"
              onChange={value => {
                setJustificativa(value.currentTarget.value);
              }}
              placeholder="informe a justificativa"
              rows={3}
            />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalEscalarSla;
